const configuration = {
	reportFunction: () => {},
};

/**
 * Configuration for `errorLogger`.
 *
 * @param {function} [reportFunction] - A function to call when an
 * error happens. The function is called with an object containing
 * details about the error.
 */
export function setConfiguration({ reportFunction } = {}) {
	configuration.reportFunction = reportFunction;
}

/**
 * Send the server details about an error that just happened on the
 * client.
 */
const send = (details) => {
	const xmlhttp = new XMLHttpRequest();

	const dataString = JSON.stringify({
		type: "fatal",
		message: details,
	});

	xmlhttp.open("POST", "/Shared/Log", true);
	xmlhttp.setRequestHeader("Content-type", "application/json");
	xmlhttp.send(dataString);
};

const report = (details) => {
	configuration.reportFunction(details);
};

// eslint-disable-next-line max-params -- we don't control the number of parameters
window.onerror = function (message, filename, lineno, colno, error) {
	let stack = "";

	if (error && error.stack) {
		stack = error.stack;
	}

	const details = {
		url: window.location.toString(),
		message,
		filename,
		lineno,
		colno,
		stack,
	};

	send(details);
	report(details);
};
